import { AxiosResponse } from 'axios';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

export type AddReactionParams = {
  commentId?: string;
  answerId?: string;
  feedbackId?: string;
  emoji: string;
};

const addReaction = async (params: AddReactionParams): Promise<AxiosResponse> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  const { data, error } = await supabase
    .from('reactions')
    .insert({
      comment_id: params.commentId || null,
      answer_id: params.answerId || null,
      feedback_id: params.feedbackId || null,
      emoji: params.emoji,
      profile_id: user.id,
    })
    .select()
    .single();

  if (error) throw error;
  return asResponse(data);
};

const removeReaction = async (id: string): Promise<AxiosResponse> => {
  const { data, error } = await supabase
    .from('reactions')
    .delete()
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return asResponse(data);
};

export default {
  addReaction,
  removeReaction,
};
